const urlReducer = (settings_return_url = "", action) => {
    switch (action.type) {
        case "SETTINGS_RETURN_URL":
            return action.payload;
        default:
            return settings_return_url;
    }
};

export default urlReducer;